import { forwardRef } from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../lib/cn';

export const Checkbox = forwardRef(function Checkbox(
  { className, checked = false, onChange, disabled, id, label, ...props },
  ref
) {
  return (
    <label
      htmlFor={id}
      className={cn(
        'inline-flex cursor-pointer items-center gap-2.5',
        disabled && 'cursor-not-allowed opacity-50',
        className
      )}
    >
      <button
        ref={ref}
        type="button"
        role="checkbox"
        aria-checked={checked}
        id={id}
        disabled={disabled}
        onClick={() => !disabled && onChange?.(!checked)}
        className={cn(
          'flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-md transition-all duration-200',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--dash-primary)]/40'
        )}
        style={{
          background: checked
            ? 'linear-gradient(135deg, #ad34fe 0%, #7b1fd4 100%)'
            : 'var(--dash-surface-subtle)',
          border: checked
            ? '1px solid rgba(173,52,254,0.6)'
            : '1px solid var(--dash-border-strong)',
          boxShadow: checked ? '0 0 12px rgba(173,52,254,0.3)' : 'none',
        }}
        {...props}
      >
        {checked && <Check size={12} strokeWidth={3.5} color="#fff" />}
      </button>
      {label && (
        <span className="text-sm" style={{ color: 'var(--dash-text)' }}>
          {label}
        </span>
      )}
    </label>
  );
});
